import QuestionService from "../services/QuestionService";
import ModuleCreator from "dev/store/ModuleCreator";

export const types = {
	ADD_GAME: "question/add-game",

};
export const params = {
	test_id: "",
	question: "",
	question_type: 1,
	question_media: "text",
	answer_id: null,
	true_false_answer: false,
	before_question: "",
	before_question_media: null,
	after_question_media: null,
	image: null,
	after_answer: "",
	hint:"",
	after_answer_media: "text",
	timer: null,
	tags: []

};


/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.question,
 @property  {array}  modules.questions
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {
		[types.ADD_GAME](context, question, game_id) {
			return QuestionService.addGame(question.id, game_id).then((response) => {
				context.commit(types.UPDATE, response);
				return response;
			});
		}
	},
	types: types
};
const quizQuestion = ModuleCreator("question", QuestionService, module, types, params);
export default quizQuestion;

